define('rebrush/components/tradein/tradein',[
    'jquery',
    'lodash',
    'cartware/components/_base',
    'cartware/jquery/bem'
], function(
    $,
    _,
    Component,
    BEM
) {
    return Component.create({
        $init: function () {

            this.block = BEM.block('checkout-tradein');
            this.deviceTypeCheckboxes = this.block.getElements('device-type-checkbox');
            this.couponCodeValue = this.block.getElements('coupon-title');

            this._initializeEvents();


        },
        _initializeEvents: function() {

            var self = this;
            this.deviceTypeCheckboxes.on('click', function(e) {
                self.couponCodeValue.show();
            });
        },

    });
});
